import React, { useEffect, useState, useRef } from "react";
import "../../../styles/desktop/chatbot.css";
import iconChat from "../../../assets/img/robot-black.png";
import RecarregarIcon from "../../../assets/svg/refreshChatbot";
import EnviarIcon from "../../../assets/svg/send";
import sendMessage from "../../../API/chatgptAPI/chatgptMessage";
import newThread from "../../../API/chatgptAPI/chatgptThread";
import listMessage from "../../../API/chatgptAPI/chatgptShowMessage";
import activator from "../../../API/chatgptAPI/chatgptActivator";
import { formatMessage } from "./formatMessage";


export default function ChatBot() {
    const [message, setMessage] = useState("");
    const [thread, setThread] = useState(localStorage.getItem("thread") || "Default");
    const [messages, setMessages] = useState([]); // Mantém todas as mensagens enviadas e recebidas
    const [isTyping, setIsTyping] = useState(false); // Controla o estado de digitação
    const messagesEndRef = useRef(null); // Referência para o fim da lista de mensagens

    useEffect(() => {
        if (thread === "Default") {
            newThread()
                .then((response) => {
                    setThread(response);
                    localStorage.setItem("thread", response);
                })
                .catch((error) => console.error("Erro ao criar nova thread:", error));
        }

        // Carregar histórico de mensagens do localStorage
        const savedMessages = localStorage.getItem("chatbotMessages");
        if (savedMessages) {
            setMessages(JSON.parse(savedMessages));
        } else {
            // Adiciona a mensagem de boas-vindas apenas se não houver mensagens salvas
            const welcomeMessage = { sender: "bot", text: "Olá! Eu sou seu assistente virtual. Como posso ajudar hoje?" };
            setMessages([welcomeMessage]);
        }
    }, [thread]);

    // Atualiza o localStorage sempre que as mensagens forem alteradas
    useEffect(() => {
        if (messages.length > 0) {
            localStorage.setItem("chatbotMessages", JSON.stringify(messages));
        }
    }, [messages]);

    const handleSendMessage = () => {
        if (message.trim() && thread !== "Default") {
            const userMessage = { sender: "user", text: message }; 
            setMessage(""); // Limpa o campo de input após o envio da mensagem
            setMessages([...messages, userMessage]); // Adiciona a mensagem do usuário à lista de mensagens
            setIsTyping(true); // Inicia o estado de digitação
            if(userMessage.text.includes("Ligar")) {
                console.log("Ligar");
            } else {
                sendMessage(thread, message)
                .then(() => {
                    fetchMessages(); // Chama a função para buscar as mensagens da thread
                    activator(thread);
                })
                .catch((error) => console.error("Erro ao enviar mensagem:", error));
            }
        }
    };

    const fetchMessages = () => {
        listMessage(thread)
            .then((response) => {
                // Verifica se a resposta é uma string
                if (typeof response === "string") {
                    const botMessage = { sender: "bot", text: response }; // Se for uma string, trata como uma mensagem do bot
                    setMessages((prevMessages) => [...prevMessages, botMessage]);
                } else if (response.data && Array.isArray(response.data)) {
                    // Se a resposta for um array, percorre e extrai as mensagens
                    const fetchedMessages = response.data.map((msg) => {
                        const content = msg?.content?.[0]?.text?.value || "Mensagem não disponível"; // Acessa o conteúdo de forma segura
                        return {
                            sender: msg.role === "user" ? "user" : "bot",
                            text: content,
                        };
                    });
                    setMessages((prevMessages) => [...prevMessages, ...fetchedMessages]); // Atualiza as mensagens
                } else {
                    console.error("Formato inesperado da resposta:", response);
                }
                setIsTyping(false); // Para a animação de digitação quando a mensagem for recebida
                scrollToBottom(); // Rola para a mensagem mais recente
            })
            .catch((error) => {
                console.error("Erro ao buscar mensagens:", error);
                setIsTyping(false); // Para a animação em caso de erro
            });
    };

    const handleResetChat = () => {
        setMessages([]); // Limpa todas as mensagens
        localStorage.removeItem("chatbotMessages"); // Remove as mensagens do localStorage
        const welcomeMessage = { sender: "bot", text: "Olá! Como posso ajudar hoje?" };
        setMessages([welcomeMessage]); // Reintroduz a mensagem de boas-vindas após resetar
        newThread()
            .then((response) => {
                setThread(response);
                localStorage.setItem("thread", response);
            })
            .catch((error) => console.error("Erro ao criar nova thread:", error));
    };

    // Função para rolar para a mensagem mais recente (para o final do conteúdo)
    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        scrollToBottom(); // Chama scrollToBottom sempre que uma nova mensagem for adicionada ou o estado isTyping mudar
    }, [messages, isTyping]); // Agora rola também ao iniciar a digitação

    // Função para enviar mensagem ao pressionar "Enter"
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Impede a quebra de linha no input
            handleSendMessage(); // Envia a mensagem
        }
    };

    return (
        <div className="ChatbotModal">
            <p className="ThreadChatbot">Thread ID: {thread}</p>
            <div className="ConversaChatbot">
                {messages.map((msg, index) => (
                    <div
                        key={index}
                        className={msg.sender === "user" ? "UserMessage" : "BotMessage"}
                    >
                        {msg.sender === "bot" && <img id="iconeChatbot" src={iconChat} alt="Bot Icon" />}
                        <p dangerouslySetInnerHTML={{ __html: formatMessage(msg.text) }} />
                    </div>
                ))}
                {isTyping && ( // Animação de digitação
                    <div className="BotMessage typing-animation">
                        <img id="iconeChatbot" src={iconChat} alt="Bot Icon" />
                        <div className="typing-dots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </div>
                    </div>
                )}
                <div ref={messagesEndRef} /> {/* Referência para rolar até o final */}
            </div>

            <div className="ChatbotInputSendModal">
                <input
                    className="ChatbotInput"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyPress={handleKeyPress} // Adiciona o evento para capturar a tecla Enter
                    placeholder="Digite sua pergunta"
                />
                <button className="SendChatbot" title="Enviar" onClick={handleSendMessage}>
                    <EnviarIcon id="iconeSendChatbot" width="50%" height="50%" />
                </button>
                <button className="SendChatbot" title="Limpar conversa" onClick={handleResetChat}>
                    <RecarregarIcon id="iconeSendChatbot" width="50%" height="50%" />
                </button>
            </div>
        </div>
    );
}
